export default "__VITE_ASSET__Bsn0mZCY__"